var exports = {
  "k": "xaf9ae18d--b34568--container",
};

module.exports = exports;
